export type DemoMessage = { sender: "customer" | "ai"; text: string };
export type DemoScript = { id: string; messages: readonly DemoMessage[] };

// All businesses, prices and conversations here are fictional marketing examples.
// The page never calls the Core, OpenAI or the WhatsApp adapter.
export const heroScript: DemoScript = {
  id: "climatizacao-hero",
  messages: [
    { sender: "customer", text: "Preciso instalar um split de 12 mil BTUs num escritório em Taubaté. Vocês fazem?" },
    { sender: "ai", text: "Fazemos sim 😊 Você já comprou o aparelho ou ainda está escolhendo?" },
    { sender: "customer", text: "Já comprei. É 220V e vai no segundo andar." },
    { sender: "ai", text: "Certo: split de 12 mil BTUs, 220V, no segundo andar. Já existe infraestrutura para a instalação?" },
    { sender: "customer", text: "Há ponto elétrico e uns 3 metros entre as unidades." },
    { sender: "ai", text: "Ótimo, já tenho os detalhes principais. Qual é seu nome e o bairro da instalação?" }
  ]
};

export const demoScripts: Record<string, DemoScript> = {
  price: {
    id: "climatizacao-preco",
    messages: [
      { sender: "customer", text: "Quanto custa instalar um split de 12 mil BTUs?" },
      { sender: "ai", text: "Nesta empresa de exemplo, a instalação padrão parte de R$ 450 (valor fictício). O preço depende da infraestrutura. O aparelho já foi comprado?" },
      { sender: "customer", text: "Sim, e o ponto elétrico já está pronto." },
      { sender: "ai", text: "Perfeito. Com o aparelho comprado e o ponto pronto, falta saber a distância entre as unidades e o bairro para orientar o próximo passo." }
    ]
  },
  hours: {
    id: "climatizacao-horario",
    messages: [
      { sender: "customer", text: "Vocês atendem aos sábados?" },
      { sender: "ai", text: "O horário informado por esta empresa de exemplo é de segunda a sexta, das 8h às 18h, e sábado, das 8h às 12h. Qual serviço você precisa?" },
      { sender: "customer", text: "Instalação de um split no meu escritório." },
      { sender: "ai", text: "Entendi. Você já tem o aparelho e a infraestrutura no local? Assim a equipe poderá avaliar sua solicitação com mais contexto." }
    ]
  },
  service: {
    id: "climatizacao-servico",
    messages: [
      { sender: "customer", text: "Vocês instalam ar-condicionado em escritório?" },
      { sender: "ai", text: "Sim, esta empresa de exemplo faz instalação de split em escritórios de Taubaté. Qual é a capacidade do aparelho e onde ele será instalado?" },
      { sender: "customer", text: "12 mil BTUs, no segundo andar." },
      { sender: "ai", text: "Anotei: split de 12 mil BTUs, segundo andar. Já existe ponto elétrico e espaço para a unidade externa?" }
    ]
  },
  product: {
    id: "climatizacao-produto",
    messages: [
      { sender: "customer", text: "Vocês trabalham com split de 12 mil BTUs?" },
      { sender: "ai", text: "Esta empresa de exemplo instala esse tipo de aparelho. Você procura comprar um equipamento ou já tem um para instalar?" },
      { sender: "customer", text: "Já tenho um modelo 220V." },
      { sender: "ai", text: "Certo, um split de 12 mil BTUs, 220V, já comprado. Em qual cidade e tipo de imóvel será a instalação?" }
    ]
  },
  human: {
    id: "climatizacao-humano",
    messages: [
      { sender: "customer", text: "Quero falar com uma pessoa sobre a instalação." },
      { sender: "ai", text: "Claro. Posso reunir os detalhes para a equipe continuar esta conversa. Qual aparelho será instalado e em qual cidade?" },
      { sender: "customer", text: "Split de 12 mil BTUs, em Taubaté." },
      { sender: "ai", text: "Entendi: instalação de split de 12 mil BTUs em Taubaté. Um operador autorizado pode assumir a conversa no Inbox com esse contexto." }
    ]
  }
};
